import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Checkbox, FormControlLabel, FormHelperText, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import IntlMessages from "../../util/IntlMessages";
import {useForm} from "react-hook-form";
import {createNewUserAction, fetchCustomers} from "../../actions";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
// import {mapObject} from "../../util/bbHelpers";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustCreateNewUser} = useSelector(({users}) => users.appMisc);
    const {customers, loadingCustomers} = useSelector(({customer}) => customer);
    // const customerMenuItems = customers
    //     ? Object.keys(customers)
    //     .map((keyName, i) =>
    //         (<MenuItem key={i} value={customers[keyName]["CustomerId"]}>{customers[keyName]["CustomerName"]} &nbsp;<small>{customers[keyName]["CustomerId"]}</small></MenuItem>
    // )) : null;
    const customerMenuItems = customers ? Object.values(customers) : null;
    customers && customerMenuItems.sort(function(a, b) {
        const textA = a.CustomerName.toUpperCase();
        const textB = b.CustomerName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    })

    // customerMenuItems
    //     .sort(function(a, b) {
    //     const textA = a.CustomerName.toUpperCase();
    //     const textB = b.CustomerName.toUpperCase();
    //     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    // });
     // console.log("customers is", customers);
  const dispatch = useDispatch();

    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [customerId, setCustomerId] = useState(null);

    const [isManager, setIsManager] = useState(false);

    // const [localLoading, setLocalLoading] = useState(false);

    const clearForm = () => {
        setFirstName("");
        setLastName("");
        setEmail("");
        setIsManager(false);
        const tempCustomerId = customerId;
        document.getElementById('NewUserForm').reset();
        setCustomerId(tempCustomerId ? tempCustomerId : "");
        document.getElementById('customerId').value = customerId;
    }

  useEffect(() => {
      if(!customers && !loadingCustomers){
          dispatch(fetchCustomers());
      }
    if(didJustCreateNewUser) {
        clearForm();
    }
    // setLocalLoading(false);
  }, [dispatch, didJustCreateNewUser, customers]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {
        // setLocalLoading(true);
        // console.log("Trying to create a new customer with data of ", data);
        // console.log("customerId", customerId);
        // console.log("firstName", firstName);
        // console.log("lastName", lastName);
        // console.log("email", email);
        // console.log("isManager", isManager);
        dispatch(createNewUserAction({
            // "customerId": data.customerId,
            // "firstName": data.firstName,
            // "lastName": data.lastName,
            // "email": data.email,
            // "isManager": data.isManager,
            "customerId": customerId,
            "firstName": firstName,
            "lastName": lastName,
            "email": email,
            "isManager": isManager,
        }));
    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">
            <h2>Create New User</h2>
            <p>This will create a new user with the associated customer company.  The user will receive an invitation via email to validate their account before they are able to log in.</p>


            <form id={"NewUserForm"} className={classes.root}>

                    {/*<TextField*/}
                    {/*    label={<IntlMessages id="appModule.register.customerId"/>}*/}
                    {/*    fullWidth*/}
                    {/*    id="customerId"*/}
                    {/*    name="customerId"*/}
                    {/*    required*/}
                    {/*    error={!!errors.customerId}*/}
                    {/*    onChange={(event) => setCustomerId(event.target.value)}*/}
                    {/*    defaultValue={customerId}*/}
                    {/*    margin="normal"*/}
                    {/*    className="mt-1 my-sm-3"*/}
                    {/*    inputRef={register({*/}
                    {/*        required: "This field is required." ,*/}

                    {/*    })}*/}
                    {/*    helperText={errors.customerId?.message}*/}
                    {/*/>*/}
                <FormControl className={classes.formControl}>
                    <InputLabel
                        id="appModule.newUser.customerId-label"
                        required
                        error={!!errors.customerId}
                    >
                        <IntlMessages id="appModule.newUser.customerId"/>
                    </InputLabel>
                    <Select
                        labelId="appModule.newUser.customerId-label"
                        id="customerId"
                        name="customerId"
                        value={customerId}
                        onChange={(event) => setCustomerId(event.target.value)}
                        displayEmpty
                        // className={classes.selectEmpty}
                    >
                        {
                            customers && customerMenuItems.map((customer, i)=>
                                    (<MenuItem key={i} value={customer["CustomerId"]}>{customer["CustomerName"]} &nbsp;<small>{customer["CustomerId"]}</small></MenuItem>
                            ))
                        }
                        {/*<MenuItem value={730528787}>Bluth</MenuItem>*/}
                        {/*<MenuItem value={2}>CIRT Pro (2)</MenuItem>*/}
                        {/*<MenuItem value={3}>CIRT Premium (3)</MenuItem>*/}
                    </Select>
                    <FormHelperText
                        error={!!errors.customerId}
                    >
                        {errors.customerId? errors.customerId?.message : " "}
                    </FormHelperText>
                </FormControl>
                <br/>
                            <TextField
                                label={<IntlMessages id="appModule.register.firstName"/>}
                                fullWidth
                                id="firstName"
                                name="firstName"
                                required
                                error={!!errors.firstName}
                                onChange={(event) => setFirstName(event.target.value)}
                                defaultValue={firstName}
                                margin="normal"
                                className="mt-1 my-sm-3"
                                inputRef={register({
                                    required: "This field is required." ,

                                })}
                                helperText={errors.firstName?.message}
                            />
                <br/>
                            <TextField
                                label={<IntlMessages id="appModule.register.lastName"/>}
                                fullWidth
                                id="lastName"
                                name="lastName"
                                required
                                error={!!errors.lastName}
                                onChange={(event) => setLastName(event.target.value)}
                                defaultValue={lastName}
                                margin="normal"
                                className="mt-1 my-sm-3"
                                inputRef={register({
                                    required: "This field is required." ,

                                })}
                                helperText={errors.lastName?.message}
                            />
                <br/>

                            <TextField
                                label={<IntlMessages id="appModule.register.email"/>}
                                fullWidth
                                id="email"
                                name="email"
                                required
                                error={!!errors.email}
                                onChange={(event) => setEmail(event.target.value)}
                                defaultValue={email}
                                margin="normal"
                                className="mt-1 my-sm-3"
                                inputRef={register({
                                    required: "This field is required." ,
                                    pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

                                })}
                                helperText={errors.email?.type === "pattern" && "Please enter a valid email address." || errors.email?.message}
                            />
                <br/>
                    <FormControl>
                        <FormControlLabel

                            control={
                                <Checkbox
                                    id="isManager"
                                    name="isManager"
                                    checked={isManager}
                                    onChange={(event) => setIsManager(event.target.checked)}
                                    // required
                                    inputRef={register({
                                        validate: {}
                                    })}
                                />
                            }
                            label={<>Is this user a Manager?<br/><small>Managers have the ability to add other users to their company.</small></>}

                        />
                        <FormHelperText
                            error={!!errors.isManager}
                        >
                            {errors.isManager? errors.isManager?.message : " "}
                        </FormHelperText>
                    </FormControl>
                    <br/>
                    <br/>
                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                disabled={!!errors.customerId || !!errors.firstName || !!errors.lastName || !!errors.email || !!errors.isManager}
                                variant="contained" color="primary">
                            <IntlMessages id="form.submit"/>
                        </Button>
                        {/*{localLoading && <CircularProgress size={30}/>}*/}
                    </div>

            </form>

        </div>
    );



}

export default Form